import { ChronoUnitLegacy } from "utils/time-utils";

export const defaultRangeDateConfig = {
    alignStartTo: ChronoUnitLegacy.HOURS,
    lag: 0,
    lagUnit: ChronoUnitLegacy.HOURS,
    lead: 0,
    leadUnit: ChronoUnitLegacy.HOURS,
    timeOffset: 0,
    timeOffsetUnit: ChronoUnitLegacy.HOURS,
  };
  
  export const defaultSingleDateSelectionConfig = {
    alignStartTo: ChronoUnitLegacy.HOURS,
    timeOffset: 0,
    timeOffsetUnit: ChronoUnitLegacy.HOURS,
  };

